import * as MuiTabs from '@mui/material/Tabs'
import React from 'react'

export type TabsProps = MuiTabs.TabsProps

export function Tabs({ children, ...props }: TabsProps) {
  return <MuiTabs.default {...props}>{children}</MuiTabs.default>
}
